export default "__VITE_ASSET__7zf9l9sa__"